<!-- 树状选择器 -->
<template>
	<el-popover
		ref="popover"
		placement="bottom-start"
		trigger="click"
		@show="onShowPopover"
		@hide="onHidePopover"
	>
		<el-tree
			ref="tree"
			class="select-tree"
			highlight-current
			:style="`min-width: ${treeWidth}`"
			:data="treeData"
			:props="defaultProps"
			accordion
            lazy
            :load="loadChildren"
			node-key="id"
			:expand-on-click-node="false"
            :default-expanded-keys="defaultExpandedKeys"
			:filter-node-method="filterNode"
			:default-expand-all="false"
			@node-click="onClickNode"
		>
		</el-tree>
		<el-input
			size="small"
			slot="reference"
			ref="input"
			v-model="treeLabel"
            v-bind="$attrs" 
            v-on="$listeners"
            v-loading="valueLoading"
			:style="`width: ${width}px`"
			:class="{ rotate: showStatus }"
            :placeholder="placeholder"
			suffix-icon="el-icon-arrow-down"
		>
		</el-input>
	</el-popover>
</template>

<script>
import { get } from "@/assets/common/request";
export default {
    inheritAttrs: false,
	name: "RoomSelectTree",
	props: {
		// 接收绑定参数
		value: {
            type: String,
            default: function() {
                return ""
            }
        },
        roomName: {
            type: String,
            default: function() {
                return ""
            }
        },
        width: {
            type: Number,
            default: function() {
                return 200
            }
        },
        // 输入框占位符
		placeholder: {
			type: String,
			required: false,
			default: "请选择",
		},
	},
	// 设置绑定参数
	model: {
		prop: "value",
		event: "selected",
	},
	computed: {
		// 若非树状结构，则转化为树状结构数据
		data() {
			return this.treeData
		},
	},
	watch: {
		treeLabel(val) {
			if (!val) {
				this.treeValue = "";
			}
			this.$refs.tree.filter(val);
		},
		treeValue(val) {
            const currentNode = this.$refs.tree.getNode(val);
            if(currentNode) {
                this.treeLabel = currentNode.label;
            }
		},
        value(val) {
            
        }
	},
	data() {
		return {
            valueLoading: false,
			// 树状菜单显示状态
			showStatus: false,
			// 菜单宽度
			treeWidth: "auto",
			// 输入框显示值
			treeLabel: "",
			// 实际请求传值
			treeValue: "0",
            treeData: [],
            defaultExpandedKeys: [],
			defaultProps: {
				value: "id", // 唯一标识
				label: "label", // 标签显示
				children: "children", // 子级
                // isLeaf: 'leaf',
                isLeaf: (data, node) => {
                    return (!node.data.children || node.data.children.length == 0 || node.level == 4) && node.level != 3
                }
			},
		};
	},
	mounted() {
        this.loadTreeData();
		this.loadValue(this.value);
		// 获取输入框宽度同步至树状菜单宽度
		this.$nextTick(() => {
			this.treeWidth = `${(this.width ||
				this.$refs.input.$refs.input.clientWidth) - 24}px`;
		});
	},
	methods: {
        loadTreeData() {
			const url = this.$requestUrl.GET_FLOOR_TREE;
			get(url).then((data) => {
				this.treeData = data.data;
			});
		},
		// 单击节点
		onClickNode(nodeData, node) {
            if(node.isLeaf) {
                this.setNodeVal(node);
			    this.onCloseTree();
            }
		},
		setNodeVal(node) {
            if(node) {
                this.treeLabel = node.data.label;
			    this.treeValue = node.data.id;
            }
		},
		// 隐藏树状菜单
		onCloseTree() {
			this.$refs.popover.showPopper = false;
		},
		// 显示时触发
		onShowPopover() {
			this.showStatus = true;
            this.$refs.tree.$emit('node-expand');
			this.$refs.tree.filter(false);
		},
		// 隐藏时触发
		onHidePopover() {
			this.showStatus = false;
			this.$emit("selected", this.treeValue);
		},
		loadChildren(node, resolve) {
            if(node.data.children) {
                return resolve(node.data.children);
            }if(node.level == 3) { // 加载房间
                const floorId = node.data.id;
                const url = `meter/web/tree/project/floor/${floorId}/room`;
                return get(url).then((data) => {
                    return resolve(data);
                });
            }
            return resolve([]);
        },
		filterNode(value, data) {
			if (!value) return true;
			return data.label.indexOf(value) !== -1;
		},
        loadValue(val) {
            if(!val) return;
            // 检测输入框原有值并显示对应 label
            const url = `meter/web/tree/project/floor/room/${val}`;
            this.valueLoading = true;
            get(url).then((data) => {
                this.treeLabel = data.label;
                this.treeValue = data.id;
            }).finally(() => {
                this.valueLoading = false;
            })
        }
	},
};
</script>

<style>
.el-input.el-input--suffix {
	cursor: pointer;
	overflow: hidden;
}
.el-input.el-input--suffix.rotate .el-input__suffix {
	transform: rotate(180deg);
}
.select-tree {
	max-height: 350px;
	overflow-y: scroll;
}
/* 菜单滚动条 */
.select-tree::-webkit-scrollbar {
	z-index: 11;
	width: 6px;
}
.select-tree::-webkit-scrollbar-track,
.select-tree::-webkit-scrollbar-corner {
	background: #fff;
}
.select-tree::-webkit-scrollbar-thumb {
	border-radius: 5px;
	width: 6px;
	background: #b4bccc;
}
.select-tree::-webkit-scrollbar-track-piece {
	background: #fff;
	width: 6px;
}
</style>
